import {webUrls} from "./web";
import {panelUrls} from "./panel";

export const urls = {
    web: webUrls,
    panel: panelUrls
}